import { render } from "./TipoPrecoModal.vue?vue&type=template&id=1c594cbe&ts=true"
import script from "./TipoPrecoModal.vue?vue&type=script&lang=ts"
export * from "./TipoPrecoModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__